import React from 'react';
import Header from '../header';
import DashBoard from '../dashboard';

const App = () => {
    return (
        <div>
            <Header></Header>
            <DashBoard></DashBoard>
        </div>
    );
};

export default App;